import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiMeGet } from '@/entities/auth/modules/api/login';
import { useAuthState } from '@/entities/auth/modules/models/useAuthState';

export const useCurrentUser = () => {
  const { isAuthenticated } = useAuthState();
  return useFetch({
    api: apiMeGet,
    keywords: queryKeys.auth.me,
    enabled: isAuthenticated,
  });
};
